export const state = () => ({
  authModal: false,
  nicknameModal: false,
  rememberUrl: '',
})

export const mutations = {
  SET_AUTH_MODAL(state, payload) {
    state.authModal = payload;
  },
  SET_NICKNAME_MODAL(state, payload) {
    state.nicknameModal = payload;
  },
  SET_REMEMBER_URL(state, payload) {
    state.rememberUrl = payload;
  }
}

export const actions = {
  showAuthModal({ commit }, payload) {
    commit('SET_AUTH_MODAL', payload)
  },
  showNicknameModal({ commit }, payload) {
    commit('SET_NICKNAME_MODAL', payload)
  },
  rememberUrl({ commit }, payload) {
    commit('SET_REMEMBER_URL', payload)
  }
}

export const getters = {
  getAuthModal: (state) => {
    return state.authModal
  },
  getNicknameModal: (state) => {
    return state.nicknameModal
  },
  getRememberUrl: (state) => {
    return state.rememberUrl
  }
}
